import React from 'react';
import EditableDataGridView from '../EditableDataGridView/EditableDataGridView';
import ComponentMemoizer from 'Global/Components/ComponentMemoizer/ComponentMemoizer';
import { standardizeEditGrid } from '../EditableDataGridView/components/functions/standardizeEditGrid/standardizeEditGrid';

const MemoEditableGrid = ({ element, field, onChange }) => {
  return (
    <React.Fragment>
      <ComponentMemoizer
        element={
          <EditableDataGridView
            Gridfields={element?.element?.ListColumnInfo?.filter(
              (fl) => fl.VisibleColumn
            )}
            InitialData={standardizeEditGrid(
              field,
              element?.element?.ListColumnInfo
            )}
            onChange={onChange}
          />
        }
        dependecies={[field, onChange]}
      />
    </React.Fragment>
  );
};

export default MemoEditableGrid;
